var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.167 14.7918C16.167 16.2186 14.9731 17.3752 13.5003 17.3752C12.0276 17.3752 10.8337 16.2186 10.8337 14.7918C10.8337 13.3651 12.0276 12.2085 13.5003 12.2085C14.9731 12.2085 16.167 13.3651 16.167 14.7918Z",
    fill: "#393ABD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.166992 8.77567C0.166992 6.99756 1.41618 5.44762 3.19685 5.01637L5.50033 4.4585L7.37535 1.73385C7.86992 1.01517 8.70254 0.583496 9.59415 0.583496H17.4065C18.2981 0.583496 19.1307 1.01517 19.6253 1.73385L21.5003 4.4585L23.8038 5.01637C25.5845 5.44762 26.8337 6.99756 26.8337 8.77567V22.5418C26.8337 24.6819 25.0428 26.4168 22.8337 26.4168H4.16699C1.95785 26.4168 0.166992 24.6819 0.166992 22.5418V8.77567ZM22.8337 9.62516C22.8337 10.3385 22.2367 10.9168 21.5003 10.9168C20.7639 10.9168 20.167 10.3385 20.167 9.62516C20.167 8.91179 20.7639 8.3335 21.5003 8.3335C22.2367 8.3335 22.8337 8.91179 22.8337 9.62516ZM18.8337 14.7918C18.8337 17.6453 16.4458 19.9585 13.5003 19.9585C10.5548 19.9585 8.16699 17.6453 8.16699 14.7918C8.16699 11.9384 10.5548 9.62516 13.5003 9.62516C16.4458 9.62516 18.8337 11.9384 18.8337 14.7918Z",
    fill: "#393ABD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.16efb5e044249d5e04b8836036ebee07.svg";
export { ForwardRef as ReactComponent };